// TECHDEBT: Create classes that implements a interface
export default {
  handleEWCompleted: (accountState) => {
    const {
      answers,
      behaviors,
      sectionsAnswers,
      customerValidation,
      savingsDataResponse,
      recaptchaVerification,
      selectedDocumentsValues,
      addressVerification,
      accountVerificationUtility
    } = accountState;

    const {
      ahri,
      contractor,
      eligibility,
      homeDetails,
      payee,
      product,
      retailer,
      schedule,
      upload,
      validate,
      terms
    } = answers;

    return {
      result: recaptchaVerification && addressVerification && accountVerificationUtility,
      customerValidation,
      userInfoAnswers: validate || [],
      eligibilityAnswers: eligibility || [],
      schedule: schedule || [],
      homeDetails: homeDetails || [],
      uploadFiles: upload || [],
      selectedDocumentsValues: selectedDocumentsValues,
      measureInputs: product || ahri || [],
      measureOutputs: savingsDataResponse,
      customerInformation: validate || [],
      payeeInformation: payee || [],
      retailerInformation: retailer || [],
      contractorInformation: contractor || [],
      accountValidated: !(behaviors?.disable_ccv_service),
      extraValuesByClass: sectionsAnswers,
      terms
    };
  },

  handleFirstBackButton: (accountState, setAccountState) => {
    const { answers } = accountState;
    setAccountState((prevAccountState) => {
      return {
        ...prevAccountState,
        answers,
      };
    });
  },

  handleNextCallback: () => { },

  handleBackCallback: () => { }
};
